import React,{useState, useContext,useEffect} from 'react'
import moment from 'moment';

function NewsletterDivSent({newsletter,orgID}) {
       const key = sessionStorage.getItem("key");
       const [showDiv, setShowDiv] = useState(false);
       const [clickedNewsNo, setClickedNewsNo] = useState(null);
       const [data, setData] = useState([{}]);
        let ge = sessionStorage.getItem('newsletter_bio')
        let news_orgs = ge?.split(" ")[ge.split(" ").length - 1]

      function handleClick (no) {
       setShowDiv((current => !current))
        setClickedNewsNo(no)
      }

      // statistik for sent newsletter
      useEffect(() => {
           const endpoint  =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_stats_get?Key=${key}&OrgNo=${news_orgs ? news_orgs : orgID}&NewsletterNo=${newsletter.No}`;
             fetch(endpoint, {
                    method: "GET",
                    headers: {
                      ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                    },
                  
                  })
                  .then(res => {    
                   return res.json()
                  })
                  .then((result) => setData(result))
      }, []);
     

  return (
       <div style={{borderBottom: showDiv === true ? '1px solid' : '',
           border: showDiv === true ? '2px solid #ccced1' : '',
          borderRadius:'2px',marginTop:'13px'}}>
         <div className='newsMailBody' onClick={() => handleClick(newsletter.No)} style={{
           border: showDiv === false ? '1px solid #ccced1' : '',
          gridTemplateColumns:'1fr 1fr 1fr 1fr 0.3fr',borderBottom:'1px solid #ccced1',cursor:'pointer'}}> 
          <p className='text_elip' style={{alignContent:'center',margin:0,paddingLeft:'16px',width:'170px'}}>{newsletter.Name}</p>
          <p style={{alignContent:'center',margin:0,width:'255px',}}>{newsletter.NewsgroupName}</p>
          <p style={{alignContent:'center',margin:0,}}>{moment(newsletter.ScheduleSendtTime).format('DD.MM.YYYY')}</p>
          <p style={{alignContent:'center',margin:0,textAlign:'center',width:'70px'}}>{moment(newsletter.ScheduleSendtTime).format('HH:MM')}</p>
         
         <p  style={{textAlign:'center',lignContent:'center',marginTop:'15px',rotate:showDiv === true && clickedNewsNo === newsletter.No ? '180deg' : ''}}><svg style={{marginTop:showDiv === true && clickedNewsNo === newsletter.No?'25px':''}} xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
          <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
          </svg></p>
         
        </div>
        {
          showDiv === true  && clickedNewsNo === newsletter.No ? <div style={{marginTop:'-10px'}}>
              <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
            <div style={{paddingTop:'10px',paddingLeft:'80px',display:'flex',justifyContent:'space-between'}}>
               <div>
                <p style={{margin:0}}>Emnefelt på nyhedsmail:</p>
                <p>Saml operaveninderne i Biohuset</p>
               </div>
               
               <div style={{marginRight:'20%'}}>
                <p style={{margin:0}}>Modtagere</p>
                {data.Recievers == data.Sendt ? 
                <p>{data.Recievers} modtagere i segmentet “Operakunder”</p>
                : <p>sendt {data.Sendt}  af {data.Recievers} emails</p>}
               </div>
             </div>
             
             <div style={{display:'flex',gap:'10px',margin:'45px 60px'}}>
              <div className='mail-boxes' style={{width:'187px',padding:'16px 20px'}}>
                <p className='head'>Åbnede mails</p>
                <p className='body'>
                  {(100/data.Recievers *  data.Opened) % 1 !== 0 ? (100/data.Recievers *  data.Opened).toFixed(1) :(100/data.Recievers * data.Opened) }%</p>
                <p className='foot'>{data.Opened} åbnede</p>
                </div>
              <div className='mail-boxes' style={{width:'187px',padding:'16px 20px'}}>
                <p className='head'>Antal klik i mail</p>
                 <p className='body'>  {(100/data.Recievers *  data.Clicked) % 1 !== 0 ? (100/data.Recievers *  data.Clicked).toFixed(1) :(100/data.Recievers * data.Opened) }%</p>
                <p className='foot'>{data.Clicked} klikkede</p>
                </div>
              <div className='mail-boxes' style={{width:'207px',padding:'16px 20px'}}><p className='head'>Afviste mails</p>
               <p className='body'>  {(100/data.Recievers *  data.Rejected) % 1 !== 0 ? (100/data.Recievers *  data.Rejected).toFixed(1) :(100/data.Recievers * data.Rejected) }%</p>
                <p className='foot'>{data.Rejected} blev afvist</p></div>
              <div className='mail-boxes' style={{width:'254px',padding:'16px 20px'}}><p className='head'>Afmeldte abonnenter</p>
                <p className='body'>0.2%</p>
                <p className='foot'>1 afmeldte sig</p>
              </div>

             </div>
              <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
           <div style={{display:'flex',gap:'10px',margin:'15px 60px'}}>
              <div className='mail-boxes' style={{width:'269px',padding:'16px 20px'}}>
                <p className='head'> Antal bestilte billetter</p>
                  <p className='body'>{data.ReservedTickets}</p>
                <p className='foot'>7.140 kr. potentielt</p>
                </div>
              <div className='mail-boxes' style={{width:'269px',padding:'16px 20px'}}> <p className='head'> Solgte billetter</p>
                  <p className='body'>{data.SoldTickets}</p>
                <p className='foot'>7.140 kr. omsat</p></div>
              <div className='mail-boxes' style={{width:'298px',padding:'16px 20px'}}> 
                <p className='head'> Salg i alt</p>
                  <p className='body'>{data.SoldAmount} kr.</p></div>
             </div> 
             <br />
             <svg style={{marginTop:'-25px'}} xmlns="http://www.w3.org/2000/svg" width="979" height="1" viewBox="0 0 979 1" fill="none">
               <path d="M0 0.5H978.5" stroke="#CCCED1"/>
            </svg>
            <br />
           <section style={{width:'540px',margin:'auto',textAlign:'center'}}>
           
                <p className='openedMailTitel' style={{paddingTop:'8px'}}>Jeres mail</p>
                
              
                <div style={{border:'1px solid #8d8d8d',borderRadius:'4px',padding:'10px',marginTop:'18px'}}>
                   <div   dangerouslySetInnerHTML={{ __html: newsletter.Body }}></div>
                </div>
              <br />
          </section>
          </div> : null
          
        }
        </div>
  )
}

export default NewsletterDivSent